import { cloneElement, Component } from '~preact';
import PropTypes from "prop-types";
import { ComponentUtils } from "../../class/ComponentUtils";
import ThemeComponent from "../theme/ThemeComponent";
import Interpret from "./Interpret";

const NO_VALUE = Symbol();

class TranslatedText extends Component {
	render({children, text, textTranslated, translationParams, translatorProps, fallback, ...props}, {}) {
		const value = text ?? children ?? NO_VALUE;

		if(value === NO_VALUE) return fallback;

		return ComponentUtils.resolvePolymorphProp(
			value,
			{
				component: c => cloneElement(c, props),
				function: f => f({
					textTranslated,
					translationParams,
					translatorProps,
					props
				}),
			},
			() => (
				textTranslated ? (
					value ?? fallback
				) : (
					<ThemeComponent
						componentType={"interpret"}
						fallback={
							<Interpret fallback={fallback}/>
						}
						suppressErrors={true}
						id={value}
						params={translationParams}
						{...translatorProps}
					/>
				)
			)
		);
	}

	static get propTypes() {
		return {
			children: PropTypes.any,

			text: PropTypes.any,
			textTranslated: PropTypes.bool,
			translationParams: PropTypes.any,
			translatorProps: PropTypes.object,

			fallback: PropTypes.any,
		}
	}
}

export default TranslatedText;
